import React from 'react';

import { ReactComponent as NewTabIcon } from '@pkg/assets/icons/v1/external-link.svg';
import { Button, ChipColor, ChipMember } from '@pkg/components';
import { useBreakpoints } from '@pkg/hooks';

import { useProfileNotificationsStore } from '@app/store/zustand/profile-page/useProfileNotificationsStore';

import { InfoModal } from './InfoModal';
import BackgroundImageSrc from './background.png';

import { Buttons, Text, Title, YatChip, YatLabel, YatWrapper } from './styles';

export const PrimaryYatModal = () => {
    const { isMobile } = useBreakpoints();
    const { selectedYat, openPrimaryYatModal, setOpenPrimaryYatModal } = useProfileNotificationsStore();

    const onClose = () => {
        setOpenPrimaryYatModal(false);
    };

    return (
        <InfoModal
            show={openPrimaryYatModal}
            onClose={onClose}
            bannerContent={
                <>
                    <YatWrapper>
                        {selectedYat && (
                            <YatChip>
                                <ChipMember yat={selectedYat} color={ChipColor.Transparent} size={'large'} />
                            </YatChip>
                        )}
                        <YatLabel>Primary Yat</YatLabel>
                    </YatWrapper>

                    <img src={BackgroundImageSrc} alt="" />
                </>
            }
            bodyContent={
                <>
                    <Title>
                        <span>🎖️</span> Meet your Primary Yat <span>🎖️</span>
                    </Title>
                    <Text>
                        <div>
                            Your Primary Yat is the one that’s connected to your upgraded Yat Profile. Primary Yats are
                            publicly visible <span>👀</span>.
                        </div>

                        <div>You can always change your Primary Yat to any other Yat that you own. </div>
                    </Text>
                    <Buttons>
                        <Button
                            to="https://support.y.at/getting-started/yat-profile/what-is-a-primary-yat"
                            size={isMobile ? 'small' : 'medium50'}
                            variant="highlight"
                            onClick={onClose}
                            startIcon={<NewTabIcon />}
                            target="_blank"
                        >
                            Learn more
                        </Button>
                    </Buttons>
                </>
            }
        />
    );
};
